<template>
  <div class="proa-error-box">
    <span class="prefix">エラー：</span>
    <span>{{ message }}</span>
  </div>
</template>

<script>
export default {
  name: 'ProaErrorBox',
  props: {
    message: String
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.proa-error-box {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  font-size: 13px;
  font-weight: 600;
  background-color: $light-error-color;
  color: $error-color;
  border: 1px solid $error-color;

  .prefix {
    display: flex;
    justify-content: center;
    align-items: center;

    &:before {
      content: "！";
      display: inline-block;
      text-align: center;
      width: 20px;
      height: 20px;
      margin-right: 10px;
      border-radius: 6px;
      background-color: $error-color;
      color: white;
    }
  }
}
</style>
